import React from 'react';
import { API } from '../../api';

const CarouselSlideContent = ({ slide, imgUrl = `${API.API_LINK}/file/pictures/carrousel/source/`, withWrapper = false }) => {
  const Content = (
    <>
      <div className="tranding-slide-img">
        {slide.typesource === 'local' ? (
          <picture>
            <img src={`${imgUrl}${slide.imgname}.${slide.extension}`} alt={`Slider N°${slide.id} IMG: ${slide.imgtitre}`} loading="lazy" />
          </picture>
        ) : (
          <img src={`${slide.imgname}.${slide.extension}`} alt={`Slider N°${slide.id} IMG: ${slide.imgtitre}`} loading="lazy" />
        )}
      </div>

      <div className="HEG-Tranding-Slide-Content">
        <h1 className="HEG-Box-Header-Text">
          {slide.evenement?.toLowerCase() !== 'aucun' ? slide.evenement : ''}
        </h1>

        <div className="HEG-Tranding-Slide-Content-Bottom">
          <h2 className="HEG-Slider-Name">{slide.imgtitre}</h2>

          <h3 className="HEG-Slider-box-bottom">
            <span>{slide.imgdescription}</span>
            <div className="rating">
              {Array.from({ length: 5 }).map((_, i) => (
                <ion-icon key={i} name="rose" />
              ))}
            </div>
          </h3>
        </div>
      </div>
    </>
  );

  if (!withWrapper) return Content;
  return <div className="tranding-slide">{Content}</div>;
};

export default CarouselSlideContent;
